import * as React from 'react';
import * as styles from './table.module.scss';

interface Props {
  children: React.ReactNode;
}

const TableBody = ({ children }: Props) => {
  return <tbody className={styles.tableHead}>{children}</tbody>;
};

export default TableBody;
